// extracted by css-extract-rspack-plugin
export default {"rcLabelWidth":"src-wab-client-components-sidebar-tabs-ColumnsSection-module__rcLabelWidth-bB5VFw","iconsMargin":"src-wab-client-components-sidebar-tabs-ColumnsSection-module__iconsMargin-mjztRG"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"rcLabelWidth\":\"src-wab-client-components-sidebar-tabs-ColumnsSection-module__rcLabelWidth-bB5VFw\",\"iconsMargin\":\"src-wab-client-components-sidebar-tabs-ColumnsSection-module__iconsMargin-mjztRG\"}";
        // 1793541995031
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  